// Cloudflare/rate-limit telemetry for real-user sessions.
// Emits structured events to dataLayer and keeps a short local history.
(function () {
  'use strict';

  var MAX_STORED_EVENTS = 100;
  var STORAGE_KEY = 'ddx_cf_signal_history_v1';
  var SESSION_DEDUPE_KEY = 'ddx_cf_signal_seen_v1';

  function nowIso() {
    try {
      return new Date().toISOString();
    } catch (_e) {
      return '';
    }
  }

  function readJson(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return fallback;
      var parsed = JSON.parse(raw);
      return parsed == null ? fallback : parsed;
    } catch (_e) {
      return fallback;
    }
  }

  function writeJson(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (_e) {}
  }

  function shouldEmitOncePerSession(signature) {
    try {
      var seen = JSON.parse(sessionStorage.getItem(SESSION_DEDUPE_KEY) || '{}');
      if (seen[signature]) return false;
      seen[signature] = 1;
      sessionStorage.setItem(SESSION_DEDUPE_KEY, JSON.stringify(seen));
      return true;
    } catch (_e) {
      return true;
    }
  }

  function pushToDataLayer(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (_e) {}
  }

  function storeLocal(payload) {
    var history = readJson(STORAGE_KEY, []);
    history.push(payload);
    if (history.length > MAX_STORED_EVENTS) {
      history = history.slice(history.length - MAX_STORED_EVENTS);
    }
    writeJson(STORAGE_KEY, history);
  }

  function emitSignal(type, detail) {
    var path = (detail && detail.path) || location.pathname;
    var signature = String(type) + '|' + String(path);
    if (!shouldEmitOncePerSession(signature)) return;

    var payload = {
      event: 'ddx_cf_signal',
      ddx_cf_type: type,
      ddx_path: path,
      ddx_page_url: location.href,
      ddx_user_agent: navigator.userAgent,
      ddx_platform: navigator.platform || '',
      ddx_message: (detail && detail.message) || '',
      ddx_timestamp: nowIso(),
    };

    pushToDataLayer(payload);
    storeLocal(payload);
  }

  function pageLooksLikeCloudflareInterstitial() {
    var title = (document.title || '').toLowerCase();
    var bodyText = ((document.body && document.body.textContent) || '').toLowerCase();

    if (title.indexOf('just a moment') !== -1) return true;
    if (bodyText.indexOf('verify you are human') !== -1) return true;
    if (bodyText.indexOf('connection needs to be verified') !== -1) return true;
    if (bodyText.indexOf('error 1015') !== -1) return true;
    return false;
  }

  function detectInterstitial() {
    if (pageLooksLikeCloudflareInterstitial()) {
      emitSignal('cloudflare_interstitial_detected', { path: location.pathname });
    }
  }

  // Listen to explicit mini-cart failure events emitted from interactable.min.js
  document.addEventListener('ddx:cf-signal', function (evt) {
    var detail = (evt && evt.detail) || {};
    emitSignal(detail.type || 'unknown_signal', detail);
  });

  // Catch challenge pages that can happen before theme JS fully initializes.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectInterstitial);
  } else {
    detectInterstitial();
  }
  setTimeout(detectInterstitial, 2500);
  setTimeout(detectInterstitial, 7000);
})();
